import { render, staticRenderFns } from "./relative-time.vue?vue&type=template&id=3ff292af&"
import script from "./relative-time.vue?vue&type=script&lang=ts&"
export * from "./relative-time.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./relative-time.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

export default component.exports